<script>

  import {mapActions, mapGetters} from 'vuex';

  import headerUtils from './HeaderUtils';
  import utilsService from 'src/services/UtilsService';

  export default {
    data: function() {
      return {
        menus: []
      }
    },
    computed: {
      ...mapGetters([
        'userLoggedRoles'
      ])
    },
    mounted: function() {
      headerUtils.resolveContractMenu(this.$route.params).then((response) => {
        this.buildMenu(this.userLoggedRoles, response.menu, this.menus);
      });
    },
    methods: {
      getLabel: function (menuItem) {

        let label = menuItem.labelPt;

        if (this.$i18n.locale == 'es' && menuItem.labelEs) {
          label = menuItem.labelEs;
        } else if (this.$i18n.locale == 'en' && menuItem.labelEn) {
          label = menuItem.labelEn;
        }

        return label;
      },
      buildMenu: function(roles, menuSource, menuTarget) {

        menuSource.map(it => {

          let menuItem = {
            id: it.id,
            labelPt: it.labelPt,
            labelEs: it.labelEs,
            labelEn: it.labelEn,
            type: it.type,
            formId: it.formId ? it.formId : null,
            childs: [],
            form: {
              availableInMobile: it.form.availableInMobile,
              availableInWeb: it.form.availableInWeb
            }
          };

          this.buildMenu(roles, it.childs, menuItem.childs);

          if (menuItem.type == 'FORM' && utilsService.hasRole(roles, it.formId) && it.form.availableInWeb) {
            menuTarget.push(menuItem);
          } else if (menuItem.childs.length > 0) {
            menuTarget.push(menuItem);
          }
        });
      },
      toggleUserMenu(menu) {
        if (this.menuActive != menu.id) {
          this.menuActive = menu.id;
        } else {
          this.menuActive = '';
        }
      }
    }
  }

</script>

<template>

  <div>

    <!--<hr>
    menusCopy
    <pre>{{menusCopy}}</pre>
    menus
    <pre>{{menus}}</pre>
    <hr>-->

    <!--<ul class="menu root">

      <li v-for="menu in menus">
        <a href="javascript:;" v-if="_userHasRole(menu)">{{menu.labelPt}}</a>
        <ul class="submenu submenu-1" v-if="menu.childs.length > 0">
          <li v-for="row in menu.childs">
            <template v-if="row.type == 'NO_LINK'">
              <a href="javascript:;">{{row.labelPt}}</a>
            </template>
            <template v-else>
              <router-link v-if="_userHasRole(row)" :to="{ name: 'ModuleList', params: { formId: row.formId } }" exact>
                {{row.labelPt}}
              </router-link>
            </template>
            <ul class="submenu submenu-2" v-if="row.childs.length > 0">
              <li v-for="row2 in row.childs">
                <template v-if="row2.type == 'NO_LINK'">
                  <a href="javascript:;">{{row2.labelPt}}</a>
                </template>
                <template v-else>
                  <router-link v-if="_userHasRole(row2)" :to="{ name: 'ModuleList', params: { formId: row2.formId } }"
                               exact>
                    {{row2.labelPt}}
                  </router-link>
                </template>
                <ul class="submenu submenu-3" v-if="row2.childs.length > 0">
                  <li v-for="row3 in row2.childs">
                    <template v-if="row3.type == 'NO_LINK'">
                      <a href="javascript:;">{{row3.labelPt}}</a>
                    </template>
                    <template v-else>
                      <router-link v-if="_userHasRole(row3)"
                                   :to="{ name: 'ModuleList', params: { formId: row3.formId } }" exact>
                        {{row3.labelPt}}
                      </router-link>
                    </template>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>

    </ul>-->

    <ul class="menu root">

      <li v-for="menu in menus">
        <a href="javascript:;">{{getLabel(menu)}}</a>
        <ul class="submenu submenu-1">
          <li v-for="row in menu.childs">
            <template v-if="row.type == 'NO_LINK'">
              <a href="javascript:;">{{getLabel(row)}}</a>
            </template>
            <template v-else>
              <router-link :to="{ name: 'ModuleList', params: { formId: row.formId } }" exact>
                {{getLabel(row)}}
              </router-link>
            </template>
            <ul class="submenu submenu-2">
              <li v-for="row2 in row.childs">
                <template v-if="row2.type == 'NO_LINK'">
                  <a href="javascript:;">{{getLabel(row2)}}</a>
                </template>
                <template v-else>
                  <router-link :to="{ name: 'ModuleList', params: { formId: row2.formId } }" exact>
                    {{getLabel(row2)}}
                  </router-link>
                </template>
                <ul class="submenu submenu-3">
                  <li v-for="row3 in row2.childs">
                    <template v-if="row3.type == 'NO_LINK'">
                      <a href="javascript:;">{{getLabel(row3)}}</a>
                    </template>
                    <template v-else>
                      <router-link :to="{ name: 'ModuleList', params: { formId: row3.formId } }" exact>
                        {{getLabel(row3)}}
                      </router-link>
                    </template>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>

    </ul>

  </div>
</template>






// WEBPACK FOOTER //
// subMenu.vue?192244c8